<template>
    <tr>
        <td>
            <button class="text-black font-sans-bold underline text-left" @click.stop.prevent="showEventDetail">
                {{event.title}}
            </button>
        </td>
        <td>{{event.festival.title}}</td>
        <td v-if="isCurrentEvent">{{event.user.fullName}}, {{event.organization.name}}</td>
        <td>{{event.created_at | dateFormat }}</td>
        <td>{{event.start_at | dateFormat }}</td>
        <td v-if="published">Published</td>
        <td v-else>
            <template v-if="status == 'new'">Draft</template>
            <template v-if="status == 'needs review'">In Review</template>
        </td>
    </tr>
</template>

<script>
    import { mapGetters } from "vuex";
    import moment from "moment";

    export default {
        name: "EventItem",
        props: {
            event: {
                required: true
            }
        },
        data: () => ({
            hasBeenApproved: false
        }),
        computed: {
            ...mapGetters({
                user: "user"
            }),
            isCurrentEvent() {
                return this.$route.name !== "past-event-list";
            },
            published() {
                if (this.hasBeenApproved) {
                    return true;
                }
                return this.event.published;
            },
            status() {
                return this.event.status;
            }
        },
        filters: {
            dateFormat(value) {
                if (value) {
                    return moment(value).format("MMM Do YYYY, h:mm a");
                }
            }
        },
        methods: {
            showEventDetail() {
                this.$store.dispatch("setActiveEvent", { data: this.event });
                this.$router.push({
                    name: "events-basics",
                    params: { id: this.event.id }
                });
            }
        }
    };
</script>
